import styled, { css } from "styled-components";
import { ButtonCommonArrowProps } from ".";

export const StyledButton = styled.div<{
  variant: ButtonCommonArrowProps["variant"];
}>`
  ${({ variant = "primary" }) =>
    variant === "primary"
      ? css`
          --background: #174a83;
          --background-hover: #456e9c;
        `
      : css`
          --background: #1890ff;
          --background-hover: #40a9ff;
        `}

  .button-view-detail {
    margin-right: 8px;
    position: relative;
    background: var(--background);
    color: white;
    border-radius: 6px;
    border: none;
    padding: 4px 8px 4px 8px;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    white-space: nowrap;

    /* Arrow shape pointing to the right */
    &.right {
      padding-right: 16px;
      clip-path: polygon(
        0% 0%,
        calc(100% - 16px) 0%,
        100% 50%,
        calc(100% - 16px) 100%,
        0% 100%
      );
    }

    /* Arrow shape pointing to the left */
    &.left {
      padding-left: 16px;
      clip-path: polygon(16px 0%, 100% 0%, 100% 100%, 16px 100%, 0% 50%);
      padding: 4px 8px 4px 16px;
    }

    /* Hover state (only when not disabled) */
    &:hover:not(:disabled) {
      background: var(--background-hover);
    }

    /* Disabled state */
    &:disabled {
      background-color: #bcbcbc !important;
      cursor: not-allowed;
    }
  }
`;
